var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStar = function SvgIconStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.423 8.26 12.333 2l-3.09 6.26-6.91 1.01 5 4.87-1.18 6.88 6.18-3.25 6.18 3.25-1.18-6.88 5-4.87-6.91-1.01Z",
    fill: "#FFA928"
  })));
};
export default SvgIconStar;